var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"movementStockDetailsChart",staticStyle:{"height":"300px"}}),_c('div',{ref:"legend",staticStyle:{"height":"100px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }